import React, { forwardRef, useState } from "react";
import { FaTimes, FaMapMarker, FaEye } from "react-icons/fa";
import {
    Card,
    Radio,
    Space,
    Button,
    Upload,
    message,
    Collapse,
    Popover,
    Modal,
} from "antd";

export function ListDalleMnt(dalleMNX) {






    return (
        <div className="scrollable-panel-content" >
            <div className="outer-div">
                {dalleMNX.dalleMNX.map((item, index) => (

                    <div className="liste_dalle inner-div" key={index}>
                            <a
                                href={item.mnt.url}
                                style={{lineHeight:1.1}}
                            >
                                {item.mnt.name}
                            </a>
                    </div>


                ))}
            </div>
        </div>
    );
}